<template>
  <div class="home">
    <div class="inner" id="titles">
      <h1 class="title">
        Paul<br />
        Thibault
      </h1>
      <h2 class="subtitle">filmmaker</h2>
    </div>
    <div class="home-wrapBackground u-posFullScreen">
      <base-video
        placeholder-src="/static/loop-placeholder.jpg"
        :src="loopSrc"
      ></base-video>
    </div>
  </div>
</template>

<script>
import BaseVideo from "@/components/BaseVideo";

export default {
  name: "home-view",
  components: {
    BaseVideo,
  },
  props: {
    mouse: Object,
    tilt: Object,
    isDesktop: Boolean,
  },

  data() {
    return {
      centerX: 0,
      centerY: 0,
      $titles: null,
      loopSrc: null,
    };
  },

  watch: {
    mouse(mouse) {
      this.updateTitle();
    },
  },

  created() {
    this.loopSrc = this.isDesktop
      ? "/static/loop.mp4"
      : "/static/loop-mobile.mp4";
  },

  mounted() {
    this.centerX = window.innerWidth / 2;
    this.centerY = window.innerHeight / 2;
    this.$titles = this.$el.querySelector("#titles");
  },

  methods: {
    updateTitle() {
      let x;
      let y;

      if (this.isDesktop) {
        x = this.mouse.x;
        y = this.mouse.y;
      } else {
        x = this.tilt.x * 12.5;
        y = this.tilt.y * 12.5;
      }

      if (x === 0 && y === 0) {
        return;
      }

      const sensibility = 0.1;

      let dX;
      let dY;
      let offsetX;
      let offsetY;

      dX = x - this.centerX;
      dY = y - this.centerY;

      offsetX = dX * sensibility;
      offsetY = dY * sensibility;

      TweenMax.set(this.$titles, {
        x: offsetX,
        y: offsetY,
        force3D: true,
      });
    },

    enter(done) {
      TweenMax.from(this.$el, 0.6, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done,
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~include-media/dist/_include-media.scss";

.home {
  position: fixed;
  inset: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.inner {
  text-align: center;
  position: relative;
  z-index: 10;
  mix-blend-mode: difference;
  color: $white-difference;
}

.title {
  margin: 0;
  text-transform: uppercase;
  font-weight: 900;
  font-size: 72px;
  line-height: 1.1;

  br {
    display: none;
  }

  .bottom {
    display: block;
  }
}

.subtitle {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 700;
  font-size: 40px;
}

.home-wrapBackground {
  position: absolute;
  inset: 0;
}

@include media("<=tablet") {
  .title {
    font-size: 36px;

    br {
      display: block;
    }
  }

  .subtitle {
    font-size: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// HomeView.vue?add12a94